import { GraphQLObjectType, GraphQLNonNull } from 'graphql'
import { dateTimeType } from './date-time-type'

export interface License {
  readonly expiration: string
}

export const license = new GraphQLObjectType({
  name: 'License',
  description: 'Information about the status of the license',
  fields: () => ({
    expiration: {
      description: 'Expiration date/time of the license',
      type: new GraphQLNonNull(dateTimeType)
    }
  })
})
